/* eslint-disable global-require */

// window._ = require('lodash');
window._ = { isEmpty: require('lodash/isEmpty') };
window.cdn = require('@SHARED/js/helpers/cdn').default;
window.collect = require('collect.js');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

const axios = require('axios');
const createAuthRefreshInterceptor = require('axios-auth-refresh').default;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const getCSRFToken = () => {
  const token = document.head.querySelector('meta[name="csrf-token"]');

  return token ? token.content : null;
};

const token = getCSRFToken();

if (token) {
  window.Laravel = { csrfToken: token };
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// https://blog.anasmazouni.dev/solving-laravel-vue-spa-419-token-mismatch/
// The following code adds an interceptor that renews the CSRF token whenever
// the app receives a token mismatch error
const refreshCSRFToken = () =>
  new Promise((resolve, reject) => {
    console.info('Token expired, fetching a new one');

    axios
      .get('/csrf-token')
      .then(({ data }) => {
        document
          .querySelector('meta[name=csrf-token]')
          .setAttribute('content', data || '');

        window.Laravel = { csrfToken: data };

        resolve();
      })
      .catch(() => reject());
  },
);

createAuthRefreshInterceptor(axios, refreshCSRFToken, {
  statusCodes: [419],
});

// Using a second interceptor to inject the newly fetched CSRF token to all requests
axios.interceptors.request.use((request) => {
  request.headers['X-CSRF-TOKEN'] = getCSRFToken();

  return request;
});
